/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrowserInfoDto
 */
export interface BrowserInfoDto {
    /**
     * 
     * @type {string}
     * @memberof BrowserInfoDto
     */
    acceptHeader?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BrowserInfoDto
     */
    colorDepth?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof BrowserInfoDto
     */
    javaEnabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BrowserInfoDto
     */
    javaScriptEnabled?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BrowserInfoDto
     */
    language?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BrowserInfoDto
     */
    screenHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BrowserInfoDto
     */
    screenWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BrowserInfoDto
     */
    timeZoneOffset?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BrowserInfoDto
     */
    userAgent?: string | null;
}

/**
 * Check if a given object implements the BrowserInfoDto interface.
 */
export function instanceOfBrowserInfoDto(value: object): value is BrowserInfoDto {
    return true;
}

export function BrowserInfoDtoFromJSON(json: any): BrowserInfoDto {
    return BrowserInfoDtoFromJSONTyped(json, false);
}

export function BrowserInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrowserInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'acceptHeader': json['acceptHeader'] === undefined ? undefined : json['acceptHeader'] === null ? null : json['acceptHeader'],
        'colorDepth': json['colorDepth'] === undefined ? undefined : json['colorDepth'] === null ? null : json['colorDepth'],
        'javaEnabled': json['javaEnabled'] === undefined ? undefined : json['javaEnabled'] === null ? null : json['javaEnabled'],
        'javaScriptEnabled': json['javaScriptEnabled'] === undefined ? undefined : json['javaScriptEnabled'] === null ? null : json['javaScriptEnabled'],
        'language': json['language'] === undefined ? undefined : json['language'] === null ? null : json['language'],
        'screenHeight': json['screenHeight'] === undefined ? undefined : json['screenHeight'] === null ? null : json['screenHeight'],
        'screenWidth': json['screenWidth'] === undefined ? undefined : json['screenWidth'] === null ? null : json['screenWidth'],
        'timeZoneOffset': json['timeZoneOffset'] === undefined ? undefined : json['timeZoneOffset'] === null ? null : json['timeZoneOffset'],
        'userAgent': json['userAgent'] === undefined ? undefined : json['userAgent'] === null ? null : json['userAgent'],
    };
}

export function BrowserInfoDtoToJSON(json: any): BrowserInfoDto {
    return BrowserInfoDtoToJSONTyped(json, false);
}

export function BrowserInfoDtoToJSONTyped(value?: BrowserInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'acceptHeader': value['acceptHeader'],
        'colorDepth': value['colorDepth'],
        'javaEnabled': value['javaEnabled'],
        'javaScriptEnabled': value['javaScriptEnabled'],
        'language': value['language'],
        'screenHeight': value['screenHeight'],
        'screenWidth': value['screenWidth'],
        'timeZoneOffset': value['timeZoneOffset'],
        'userAgent': value['userAgent'],
    };
}

